import styled from 'styled-components';
import Button from '../Button';
import Input from '../Input';

const PrimaryHeader = styled.header`
.zaggle-logo{
  width: 50%;
}
background:${(props) => props.theme.ghostWhite};
color: ${(props) => props.theme.whiteColor};
font-size: 12px;
padding: 15px 0px;
display: block;
padding-top: -15px;
.logo-bg-color{
  position: relative;
  padding-left: 55px !important; 
  &:after{
    content: "";
    position: absolute;
    background:${(props) => props.theme.primaryColor};
    width: 65px;
    height: 100%;
    top: 0;
    right: 0;
    display:none;
  }
}
.secondary-menu{
    margin:0px;
    padding:0px;
    list-style:none;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    li{
      a, .nav-secondary-drop-link{
        font-size: 13px;
        color: ${(props) => props.theme.blackColor};
        &:hover{
          color: ${(props) => props.theme.primaryLight};
        }
      }
    }
  }
.header_search{
  float:right;
  margin:0px;
  padding:0px;
  .pull-left{
    position:absolute;
    left:0;
    top:12px;
  }
  li{
    display: inline-block;
    margin-left: 20px;
    position: relative;
    &:nth-last-child(2) { 
      margin-top: 8px;
    }
    &:nth-last-child(1) { 
      margin-top: 8px;
    }
    .log-in{
      cursor: pointer;
      &.disable{
        opacity: .2;
      }
    }
    .badge{
      position: absolute;
      background: #5d0207;
      top: -11px;
      right: -15px;
      border-radius: 50%;
      font-size: 10px;
      padding: 1px;
      min-width: 18px;
      height: 18px;
      text-align: center;
      line-height: 15px;
    }
    a{
      color: #636363;
      text-decoration:none;
    }
    span{
      color: #636363;
      text-decoration:none;
    }
  }
  .Select{
    width: 97px;
    float: left;
    margin-top: 1px;
    margin-right: 1px;
    .Select-control{
      border: none;
      outline: none;
      color: ${(props) => props.theme.blackColor};
      border-radius: 0;
      height: 28px;
      .Select-clear{
        display:none;
      }
      .Select-placeholder, .Select--single > .Select-control .Select-value{
        line-height: 28px;
      }
      .Select-value{
        line-height: 28px;
        font-size: 11px;
        padding-right: 10px !important;
      }
      .Select-input{
        height:28px;
      }
      .Select-input{
        height:28px;
      }
    }
  }
    ${Input} {
      border: none;
      padding: 7px;
      width: 275px;
      outline: none;
      color: ${(props) => props.theme.blackColor};
      border-radius: 0;
      background:${(props) => props.theme.whiteColor};
    }
    ${Button} {
      border: none;
      background: #f75d60;
      color: ${(props) => props.theme.whiteColor};
      border-radius: 0;
      margin: 0;
      margin-left: 5px;
      span{
        color: ${(props) => props.theme.whiteColor};
      }
    }
  }
`;

export default PrimaryHeader;



// WEBPACK FOOTER //
// client/components/PrimayHeader/index.js